import { http } from "@canvas/api";

export interface UserEcsSearchReq {
  endpoint: "wakanda.api.v1.users.:userId.ecs";
  user_id: string | number;
}

export interface UserEcsSearchRes {
  error: string;
  response: ECResp[];
}
export interface ECResp {
  id: number | string;
  is_deleted: boolean;
  name: string;
  display_name: string;
  city: string;
}

export function get(req: UserEcsSearchReq): Promise<UserEcsSearchRes> {
  return http
    .GET(`/wakanda/api/v1/users/${req.user_id}/ecs`)
    .then((response: UserEcsSearchRes) => {
      // validate response here
      return response;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
